import React from 'react';
import CallForProposalForm from './Form';

const CallForProposalFormView = () => {
  return (
    <div className="block cfp-form-block">
      <div className="cfp-form-surface">
        <CallForProposalForm />
      </div>
    </div>
  );
};

export default CallForProposalFormView;
